import React, { FC } from 'react';
import { Box, Layout, Cell } from '@wix/design-system';
import s from '../../styles/page.scss';

export interface OneColumnLayoutProps {
  content: React.ReactNode;
}

export const OneColumnLayout: FC<OneColumnLayoutProps> = ({ content }) => {
  return (
    <Layout>
      <Cell span={12}>
        <Box className={s.sectorBoxWrapper}>{content}</Box>
      </Cell>
    </Layout>
  );
};
